// DS1.7.5
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { ThumbStatusTypes } from '../types';
import s from './ThumbStatusIndicator.scss';

interface Props {
  type: ThumbStatusTypes;
  size: 'small' | 'medium' | 'large';
  hasAccess?: boolean;
  className?: string;
}

const validCombinations: {
  [t in Props['type']]: Props['size'][];
} = {
  'in-tier': ['large', 'medium', 'small'],
  'premium-folder': ['large', 'medium', 'small'],
  'watchers-only-folder': ['large', 'medium'],
  commission: ['large', 'medium', 'small'],
  adoptable: ['large', 'medium', 'small'],
  pcp: ['large', 'medium', 'small'],
  nft: ['medium'],
};

const fileNameMap: {
  [t in Props['type']]?: string;
} = {
  'in-tier': 'tier',
  'premium-folder': 'pg',
  'watchers-only-folder': 'watchers',
  pcp: 'premium-download',
  adoptable: 'adopt',
  commission: 'commission',
};

const ThumbStatusIndicator: React.FC<Props> = ({
  type,
  size,
  className,
  hasAccess,
}) => {
  // not all combinations exist
  if (!validCombinations[type].includes(size)) {
    return null;
  }

  let fileName = fileNameMap[type] ?? type;
  if (fileName === 'tier') {
    fileName = hasAccess ? 'tier' : 'locked';
  }

  return (
    <div className={classnames(s['root'], s[size], className)}>
      <img
        alt=""
        className={s['image']}
        src={Url.staticCDNLink(
          `eclipse/global/svg/deviation-status-icons/v2/${fileName}-${size}.svg?26`
        )}
      />
    </div>
  );
};
ThumbStatusIndicator.displayName = 'ThumbStatusIndicator';

export default ThumbStatusIndicator;
